var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-group row" }, [
      _c("div", { staticClass: "col-sm-4 col-form-label" }, [
        _vm._v("Ansprechpartner"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-8" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localContact.name,
              expression: "localContact.name",
            },
          ],
          staticClass: "form-control",
          domProps: { value: _vm.localContact.name },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.localContact, "name", $event.target.value)
            },
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group row" }, [
      _c("div", { staticClass: "col-sm-4 col-form-label" }, [
        _vm._v("E-Mail-Adresse(n)"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-8" },
        [
          _c("comma-separated-input", {
            attrs: { type: "email" },
            model: {
              value: _vm.localContact.email,
              callback: function ($$v) {
                _vm.$set(_vm.localContact, "email", $$v)
              },
              expression: "localContact.email",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group row" }, [
      _c("div", { staticClass: "col-sm-4 col-form-label" }, [
        _vm._v("Telefon"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-8" },
        [
          _c("comma-separated-input", {
            attrs: { type: "tel", placeholder: "+491234567" },
            model: {
              value: _vm.localContact.phone,
              callback: function ($$v) {
                _vm.$set(_vm.localContact, "phone", $$v)
              },
              expression: "localContact.phone",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group row" }, [
      _c("div", { staticClass: "col-sm-4 col-form-label" }, [
        _vm._v("Organisation"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-8" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localContact.org,
              expression: "localContact.org",
            },
          ],
          staticClass: "form-control",
          domProps: { value: _vm.localContact.org },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.localContact, "org", $event.target.value)
            },
          },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }